module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', [(_vm.showRotate) ? _c('el-col', {
    attrs: {
      "span": 3,
      "align": "left"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text",
      "icon": "fa fa-undo"
    },
    on: {
      "click": function($event) {
        _vm.rotate -= 90
      }
    }
  }, [_vm._v(" Rotate")])], 1) : _vm._e(), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": _vm.showRotate ? 18 : 24
    }
  }, [(_vm.pageCount) ? _c('pdf-toolbar', {
    attrs: {
      "total-pages": _vm.pageCount
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1), _vm._v(" "), (_vm.showRotate) ? _c('el-col', {
    attrs: {
      "span": 3,
      "align": "right"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "text"
    },
    on: {
      "click": function($event) {
        _vm.rotate += 90
      }
    }
  }, [_vm._v("Rotate "), _c('i', {
    staticClass: "fa fa-undo fa-flip-horizontal"
  })])], 1) : _vm._e()], 1), _vm._v(" "), _c('el-row', {
    attrs: {
      "type": "flex",
      "justfy": "center"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('pdf', {
    staticStyle: {
      "width": "100%",
      "height": "auto"
    },
    attrs: {
      "src": _vm.url,
      "rotate": _vm.rotate,
      "page": _vm.currentPage
    },
    on: {
      "num-pages": function($event) {
        _vm.pageCount = $event
      },
      "page-loaded": function($event) {
        _vm.currentPage = $event
      },
      "link-clicked": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)], 1), _vm._v(" "), (_vm.showPageNumbersBottom && _vm.pageCount) ? _c('pdf-toolbar', {
    attrs: {
      "total-pages": _vm.pageCount
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e7581044"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/PdfViewer.vue
// module id = 1729
// module chunks = 0